import { useEffect, useState } from 'react';
import AndroidSuccessModal from './android-success-modal/components/android-success-modal';
import { QUERY_MOBILE } from '../../../../constants/query-params/mobile';
import serializeQueryParams from '../../../../utils/url/serialize-query-params';
import { SUCCESS_PAGE_DEEPLINKS } from '../../payment.constants';
import Routes from '../../../../constants/routes';
import isMobileAppWithDeeplinkRedirect, { isMobileAppAndroid } from '../../../../utils/is-mobile-app';

type SuccessRedirectProps = {
    needRedirect: boolean;
    orderToken: string;
};

const SuccessRedirect = ({ needRedirect, orderToken }: SuccessRedirectProps) => {
    const queryParams = serializeQueryParams();
    const [androidDeeplink, setAndroidDeeplink] = useState('');

    useEffect(() => {
        if (!needRedirect) {
            return;
        }

        // For Mobile App
        if (isMobileAppWithDeeplinkRedirect()) {
            const url = `${SUCCESS_PAGE_DEEPLINKS.REGULAR}?token=${orderToken}`;

            if (isMobileAppAndroid()) {
                setAndroidDeeplink(url);

                return;
            }

            setTimeout(() => {
                window.location.href = url;
            }, Number(queryParams[QUERY_MOBILE.REDIRECT_DELAY] || 2000));
        } else { // For Web
            window.location.href = `${Routes.THANK_YOU_PAGE.path}?token=${orderToken}`;
        }
    }, [needRedirect]);

    return (needRedirect && androidDeeplink)
        ? <AndroidSuccessModal deeplink={androidDeeplink}/>
        : <></>;
};

export default SuccessRedirect;
